<template>
	<div class="page-container">
		<div class="TopBut">
			<button class="but" :class="['but' + (index + 1)]" v-for="(item, index) in topbuts" :key='index'
				@click="routerurl(index)">
				<div>
					{{ item.title }}
					<div>
						<span>{{ item.num1 }}/{{ item.num2 }}</span>
					</div>
				</div>
			</button>
		</div>
		<div class="sb">
			<div class="towmain">
				<div class="towmain_name">合同到期消息处理</div>
				<div class="towmain_name_main">
					<el-table :data="tableData" :max-height="tableheitgh">
						<el-table-column fixed prop="room_num" label="房间号" header-align="center" align="center">
						</el-table-column>
						<el-table-column prop="name" label="姓名" header-align="center" align="center">
						</el-table-column>
						<el-table-column prop="phone" label="手机号" header-align="center" align="center">
						</el-table-column>
						<el-table-column label="到期天数" header-align="center" align="center">
							<template slot-scope="scope">
								<span style="color:#ff4949 ">
									{{ scope.row.day }}
								</span>
							</template>
						</el-table-column>
						<el-table-column label="是否忽略" header-align="center" align="center">
							<template slot-scope="scope">
								<span :style="{ color: scope.row.msg_hl ? '#1bad1a' : '#F29900' }">
									{{ scope.row.msg_hl == true ? '是' : '否' }}
								</span>

							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" header-align="center" align="center">
							<template slot-scope="scope">
								<el-button :disabled="scope.row.msg_hl" @click.native.prevent="deleteRow(scope.row)" type="text"
									size="small">
									忽略
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="button_main">
				<div v-resize="resize" ref="chartContainer" id="echarts1"></div>
			</div>
		</div>

	</div>
</template>

<script>
import * as echarts from 'echarts';
import {
	index_data,
	contract_endtime,
	msg_hl
} from '../../api/api.js'
export default {
	directives: { // 使用局部注册指令的方式
		resize: {
			bind (el, binding) {
				let width = '',
					height = '';

				function isReize () {
					const style = document.defaultView.getComputedStyle(el);
					if (width !== style.width || height !== style.height) {
						if (binding.value && typeof binding.value === 'function') {
							binding.value(); // 调用前检查是否为函数
						}
					}
					width = style.width;
					height = style.height;
				}

				el.__vueSetInterval__ = setInterval(isReize, 300);
			},
			unbind (el) {
				clearInterval(el.__vueSetInterval__);
			}
		}
	},
	data () {
		return {
			topbuts: [{
				title: '近七天新增报修',
				num1: 0,
				num2: 270,
			}, {
				title: '近七天新增用户',
				num1: 0,
				num2: 270,
			}, {
				title: '近七天房租账单数',
				num1: 0,
				num2: 270,
			}, {
				title: '近七天总账单数',
				num1: 0,
				num2: 270,
			},],
			topbuturl: ['User/repair', '/User/user', '/Bills/bills', '/Bills/orders'],
			funpages: [{
				title: '未处理报修',
				num1: 0,
				num2: 270,
			}, {
				title: '逾期订单',
				num1: 0,
				num2: 270,
			}, {
				title: '未出租房源',
				num1: 0,
				num2: 270,
			}, {
				title: '已到期合同',
				num1: 0,
				num2: 270,
			}, {
				title: '本月到期合同',
				num1: 0,
				num2: 270,
			}, {
				title: '下月到期合同',
				num1: 0,
				num2: 270,
			},],
			option: {
				title: {
					text: '数据报表',
					textStyle: {
						fontSize: 18 // 默认 PC 字号
					}
				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: ['新增报修', '新增用户', '房租订单', '总订单', '总金额(单位K)'],
					textStyle: {
						fontSize: 14 // 默认 PC 字号
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				toolbox: {
					feature: {
						saveAsImage: {
							title: "保存图片"
						}
					}
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'],
					axisLabel: {
						fontSize: 16 // 默认 PC 字号
					}
				},
				yAxis: {
					type: 'value'
				},
				series: [{
					name: '新增报修',
					type: 'line',
					stack: 'Total',
					data: []
				},
				{
					name: '新增用户',
					type: 'line',
					stack: 'Total',
					data: []
				},
				{
					name: '房租订单',
					type: 'line',
					stack: 'Total',
					data: []
				},
				{
					name: '总订单',
					type: 'line',
					stack: 'Total',
					data: []
				},
				{
					name: '总金额(单位K)',
					type: 'line',
					stack: 'Total',
					data: []
				}
				]
			},
			chartInstance: null,
			tableData: [],
			tableheitgh: ''
		}

	},
	methods: {
		Echarts (data) {
			this.option.series[0].data = data.row2.repair_add;
			this.option.series[1].data = data.row2.user;
			this.option.series[2].data = data.row2.rent_bill;
			this.option.series[3].data = data.row2.bill;
			this.option.series[4].data = data.row2.money;

			// 只有当元素存在时才初始化
			const chartDom = document.getElementById('echarts1');
			if (!chartDom) return;

			if (this.chartInstance) {
				this.chartInstance.setOption(this.option);
				this.chartInstance.resize(); // 更新后 resize
			} else {
				this.chartInstance = echarts.init(chartDom);
				this.chartInstance.setOption(this.option);
			}
		},
		onWindowResize () {
			// if (this.chartInstance) {
			this.chartInstance.resize();
			// }
		},
		resize () {
			// if (this.chartInstance) {
			this.chartInstance.resize();
			// }
		},
		changerow (data) {

			this.topbuts[0].num1 = data.row1.repair7.add
			this.topbuts[0].num2 = data.row1.repair7.total
			this.topbuts[1].num1 = data.row1.user7.add
			this.topbuts[1].num2 = data.row1.user7.total
			this.topbuts[2].num1 = data.row1.bill7.add
			this.topbuts[2].num2 = data.row1.bill7.total
			this.topbuts[3].num1 = data.row1.bill7t.add
			this.topbuts[3].num2 = data.row1.bill7t.total
			this.funpages[0].num1 = data.row1.repair.no
			this.funpages[0].num2 = data.row1.repair.total
			this.funpages[1].num1 = data.row1.bill.overdue
			this.funpages[1].num2 = data.row1.bill.total
			this.funpages[2].num1 = data.row1.house.no
			this.funpages[2].num2 = data.row1.house.total
			this.funpages[3].num1 = data.row1.contract.end
			this.funpages[3].num2 = data.row1.contract.month_total + data.row1.contract.net_month_total
			this.funpages[4].num1 = data.row1.contract.month_overdue
			this.funpages[4].num2 = data.row1.contract.month_total
			this.funpages[5].num1 = data.row1.contract.net_month_overdue
			this.funpages[5].num2 = data.row1.contract.net_month_total

		},
		routerurl (index) {
			this.$router.push(this.topbuturl[index])
		},
		handleResize () {
			const width = window.innerWidth;
			if (width <= 768) { // 假设小于等于768px为移动设备
				this.updateMobileChartStyle();
			}

			if (this.chartInstance) {
				this.chartInstance.setOption(this.option);
				this.chartInstance.resize();
			}
		},
		updateMobileChartStyle () {
			this.option.title.top = '5%';
			this.option.legend.top = '15%';
			this.option.grid.top = '44%';
			this.option.grid.bottom = '10%';
			this.option.title.textStyle.fontSize = 14;
			this.option.legend.textStyle.fontSize = 10;
			this.option.xAxis.axisLabel.fontSize = 12;
			this.option.grid.right = "8%";
		},
		deleteRow (row) {
			console.log(row);
			this.$confirm(`确定忽略${row.room_num}的合同到期提醒吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				center: true
			}).then(() => {
				msg_hl({
					cid: row.id
				}).then(res => {
					if (res.status == 200) {
						contract_endtime().then(res => {
							this.tableData = res.data
						})
					}
				})

			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		}
	},
	mounted () {
		this.handleResize();
		// this.Echarts()
		window.addEventListener('resize', this.onWindowResize.bind(this)); // 注意这里使用了不同的方法

		const width = window.innerWidth;
		const baseSize = Math.max(width / 10800 * 100, 10.65); // min: 10.65px
		this.tableheitgh = baseSize * 30
		// console.log('🔧 rem:', );

	},
	beforeDestroy () {
		window.removeEventListener('resize', this.onWindowResize);

		if (this.chartInstance) {
			this.chartInstance.dispose(); // 正确销毁 ECharts 实例
			this.chartInstance = null; // 避免残留引用
		}
	},
	created () {

		this.handleResize();
		index_data().then(res => {
			if (res.status == 200) {
				this.changerow(res.data)
				this.Echarts(res.data)
			}
		})
		contract_endtime().then(res => {
			this.tableData = res.data
		})
	},
}
</script>

<style scoped>
.page-container {
	/* background-color: red; */
}

.TopBut {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.625rem;
	margin: 1rem 2.2rem;
	background-color: var(--cont_backgound);
	padding: 1rem;
	border-radius: 8px;
}

.but {
	border: none;
	height: 6.25rem;
	flex: 1;
	min-width: 12rem;
	border-radius: 8px;
	color: #fff;
	transition: 0.2s ease;
	line-height: 1.45rem;
	font-weight: bold;
	font-size: 0.85rem;
	box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}

.but:hover {
	transition: all 0.2s;
	transform: scale(1.01);
}

.but1 {
	background-image: linear-gradient(40deg, #53A8FF 30%, #7FD6E6);
}

.but2 {
	background-image: linear-gradient(40deg, #67C23A 30%, #B3E09C);
}

.but3 {
	background-image: linear-gradient(40deg, #E6A23C 30%, #F5DAB1);
}

.but4 {
	background-image: linear-gradient(40deg, #F56C6C 30%, #F9AEAE);
}

.but5 {
	background-image: linear-gradient(40deg, #1BBCDD 30%, #6cd6e8);
}

.but6 {
	background-image: linear-gradient(40deg, #53A8FF 30%, #7FD6E6);
}

.but7 {
	background-image: linear-gradient(40deg, #67C23A 30%, #B3E09C);
}

.but8 {
	background-image: linear-gradient(40deg, #E6A23C 30%, #F5DAB1);
}

.but9 {
	background-image: linear-gradient(40deg, #F56C6C 30%, #F9AEAE);
}

.but10 {
	background-image: linear-gradient(40deg, #53A8FF 30%, #7FD6E6);
}

.towmain {
	background-color: var(--cont_backgound);
	padding: 1rem;
	border-radius: 8px;
	flex: 1;
	margin-right: 0.5rem;
}

.towmain_name {
	margin-bottom: 1rem;
	font-weight: bold;
	color: #464646;
}

.textlist {
	flex-basis: calc(33.33% - 1.8rem);
	margin-bottom: 0.625rem;
	display: flex;
	justify-content: space-between;
	transition: 0.3s ease;
	line-height: 1rem;
}

.textlist:hover {
	transition: all .2s;
	font-size: 0.88rem;
	font-weight: bold;
}

.button_main {
	background-color: var(--cont_backgound);
	padding: 1rem;
	border-radius: 8px;
	flex: 1;
	margin-left: 0.5rem;
}

.sb {
	display: flex;
	margin: 1rem 2.2rem;
	gap: 1rem;
}

#echarts1 {
	width: 100%;
	height: 32rem;
}

@media (max-width:1550px) {
	.TopBut {
		margin: 1rem 2rem;
	}

	.sb {
		display: block;
		margin: 1rem 2rem;
	}

	.towmain {
		margin: 1rem 0;
		background-color: var(--cont_backgound);
		border-radius: 8px;
		padding: 1rem;
		width: 100%;
		margin-right: 0;
	}

	.button_main {
		margin: 1rem 0;
		margin-left: 0;
	}

	.towmain_name {
		margin-bottom: 1rem;
		font-weight: bold;
		color: #464646;
		font-size: 1.34rem;
	}

	#echarts1 {
		width: 100%;
		height: 32rem;
	}
}

@media (max-width: 768px) {

	.TopBut {
		flex-wrap: wrap;
		margin: 1rem 1rem;
	}

	.but {
		width: 46%;
		height: 6rem;
		line-height: 1.2;
	}

	.sb {
		display: block;
		margin: 1rem 1rem;
	}

	.towmain {
		margin: 1rem 0;
		background-color: var(--cont_backgound);
		border-radius: 8px;
		padding: 1rem;
		width: 100%;
		height: auto;
		min-height: 32rem;
		margin-right: 0;
	}

	.button_main {
		margin: 1rem 0;
		margin-left: 0;
	}

	.towmain_name {
		margin: 0.5rem 0;
		font-size: 1.2rem;
		margin-bottom: 1rem;
	}

	#echarts1 {
		width: 100%;
		height: 28rem;
	}

}
</style>